import { useEffect, useState, useCallback } from "react";
import { usePlaidLink } from "react-plaid-link";

import { createPlaidLink } from "features/SurmountAccount/service";

export const usePlaid = ({ active = false, successCallback, exitCallback }) => {
  const [plaidConfig, setPlaidConfig] = useState({
    token: "",
  });

  const { ready, open } = usePlaidLink(plaidConfig);

  useEffect(() => {
    if (!active) {
      return;
    }

    (async () => {
      try {
        const response = await createPlaidLink();
        setPlaidConfig({
          ...plaidConfig,
          token: response.link_token,
          onSuccess,
          onExit,
        });
      } catch (error) {
        console.error("error: ", error);
      }
    })();
  }, [active]);

  const onSuccess = useCallback(
    async (public_token, metadata) => {
      try {
        successCallback(public_token, metadata);
      } catch (error) {
        console.error("error: ", error);
      }
    },
    [plaidConfig.token]
  );

  const onExit = useCallback(
    (err) => {
      if (exitCallback) exitCallback();
      if (err) console.error("Plaid Err: ", err);
    },
    [plaidConfig.token]
  );

  return { ready, open };
};
